import { GzDropdownMenuWebComponent } from './component/GzDropdownMenuWebComponent';

export { GzDropdownMenuWebComponent };
